import { Card, CardContent } from "@mui/material";
import React from "react";
import Controls from "../../../../components/form/controls/Controls";

const SkillConfig = ({
  values,
  handleInputChange,
  listEvent,
  listContext,
  id,
  updateSkillName,
  intentValues,
}) => {
  return (
    <div style={{ border: "dashed 1px" }}>
      <div style={{ padding: "20px" }}>
        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5>Main-intent config</h5>
          </div>

          <div style={{ display: "flex" }}>
            <div style={{ width: "50%", padding: "40px" }}>
              <Card sx={{ marginTop: "25px" }}>
                <CardContent>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Controls.Select
                      name="eventId"
                      label="Event"
                      value={values.eventId}
                      onChange={handleInputChange}
                      options={listEvent.map((event) => ({
                        ...event,
                        name: `${event.eventNamespace} - ${event.eventName}`,
                      }))}
                      disabled={Boolean(id)}
                    />
                    <Controls.Select
                      name="contextId"
                      label="contexts"
                      value={values.contextId}
                      onChange={handleInputChange}
                      options={listContext.map((context) => ({
                        ...context,
                        name: `${context.contextNamespace} - ${context.contextName}`,
                      }))}
                      style={{ marginLeft: "10px" }}
                      disabled={Boolean(id)}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Controls.Input
                      name="skillName"
                      sx={{
                        width: "50%",
                        marginTop: "10px",
                      }}
                      value={values.skillName}
                      label="Skill name"
                      type="text"
                      onChange={handleInputChange}
                    />
                    <Controls.Button
                      sx={{
                        width: "50%",
                        marginTop: "10px",
                        marginLeft: "10px",
                      }}
                      color="primary"
                      type="button"
                      text="update skill name"
                      disabled={!values.eventId || !values.contextId}
                      onClick={() =>
                        updateSkillName(intentValues ? intentValues : "[]")
                      }
                    />
                  </div>
                </CardContent>
              </Card>
            </div>

            <div style={{ width: "50%", padding: "40px" }}>
              <div style={{ marginBottom: "10px" }}>
                <h5>Main-intent values</h5>
              </div>
              <Card>
                <CardContent sx={{ height: "300px", overflow: "auto" }}>
                  {intentValues ? (
                    <pre>{JSON.stringify(intentValues, null, 2)}</pre>
                  ) : (
                    <pre>Intent Empty, pick template and apply</pre>
                  )}
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillConfig;
